import React from 'react';
import { View, Text } from 'react-native';
import { useThemeColors } from '@/lib/useThemeColors';
import { labelThemeColor, scoreToLabel } from '@/lib/scoring/score-display';
import type { VentureLabel } from '@/lib/scoring/methodology';

interface VerdictTagProps {
  score?: number;
  ventureLabel?: VentureLabel | string;
}

export function getVerdictText(score?: number, ventureLabel?: string): string {
  if (score === undefined) return 'Not Scored';
  if (score >= 80) return 'Highly Investable';
  if (score >= 60) return 'Investment Ready';
  if (score >= 40) return 'Developing';
  return 'Early Stage';
}

export function VerdictTag({ score, ventureLabel }: VerdictTagProps) {
  const colors = useThemeColors();
  const resolvedLabel = ventureLabel ?? (score !== undefined ? scoreToLabel(score) : undefined);
  const text = getVerdictText(score, resolvedLabel as string);
  const tint = resolvedLabel
    ? labelThemeColor(resolvedLabel as string, colors)
    : colors.text.tertiary;

  return (
    <View
      style={{
        alignSelf: 'flex-start',
        flexDirection: 'row',
        alignItems: 'center',
        paddingHorizontal: 10,
        paddingVertical: 5,
        borderRadius: 999,
        backgroundColor: `${tint}15`,
        borderWidth: 1,
        borderColor: `${tint}30`,
      }}
    >
      <View
        style={{
          width: 6,
          height: 6,
          borderRadius: 3,
          backgroundColor: tint,
          marginRight: 6,
        }}
      />
      <Text
        style={{
          color: tint,
          fontSize: 11,
          fontWeight: '700',
          letterSpacing: 0.2,
        }}
        numberOfLines={1}
      >
        {text}
      </Text>
    </View>
  );
}
